export default "__VITE_ASSET__a41aef62__"